// Global
export const SHOW_ALERT = 'showAlert';
export const HIDE_ALERT = 'hideAlert';
export const SET_ALERT_TEMPLATE = 'setAlertTemplate';

export const SHOW_PROMPT = 'showPrompt';
export const HIDE_PROMPT = 'hidePrompt';
export const SET_PROMPT_TEMPLATE = 'setPromptTemplate';

export const SHOW_SNACKBAR = 'showSnackbar';
export const HIDE_SNACKBAR = 'hideSnackbar';

export const FIRE_FLEX_EVENT = 'fireFlexEvent';
export const SET_SETTINGS_DATA = 'setSettingsData';

// Page
export const ADD_RECENT = 'addRecent';
export const ADD_SELECTED_ELEMENT = 'addSelectedElement';
export const CLEAR_COPIED_MENU_DATA = 'clearCopiedMenuData';
export const CLEAR_COPIED_RENDERING = 'clearCopiedRendering';
export const CLEAR_DELETED_MENU_DATA = 'clearDeletedMenuData';
export const CLEAR_SELECTED_ELEMENT = 'clearSelectedElement';
export const CLEAR_SELECTED_ELEMENTS = 'clearSelectedElements';
export const CLEAR_SELECTED_LINK = 'clearSelectedLink';
export const CLEAR_SELECTED_RENDERING = 'clearSelectedRendering';
export const HIDE_DRAWER = 'hideDrawer';
export const HIDE_MODAL = 'hideModal';
export const LOAD_TEMPLATE = 'loadTemplate';
export const MOUNT_FAVORITES = 'mountFavorites';
export const MOVE_RENDERING = 'moveRendering';
export const REMOVE_FAVORITE = 'removeFavorite';
export const REMOVE_SELECTED_ELEMENT = 'removeSelectedElement';
export const SELECT_PARENT_ELEMENT = 'selectParentElement';
export const SET_APP_THEME = 'setAppTheme';
export const SET_APP_THEME_LIST = 'setAppThemeList';
export const SET_CAROUSEL_SPEED = 'setCarouselSpeed';
export const SET_CH_TOKEN = 'setCHToken';
export const SET_CHANGED_DATA = 'setChangedData';
export const SET_CHANGED_OPTION = 'setChangedOption';
export const SET_COMPONENT_TREE = 'setComponentTree';
export const SET_CONTEXT_ELEMENT = 'setContextElement';
export const SET_COPIED_ELEMENTS = 'setCopiedElements';
export const SET_CUT_CALLBACK = 'setCutCallback';
export const SET_DEVICE_MODE = 'setDeviceMode';
export const SET_EDITOR_MODE = 'setEditorMode';
export const SET_HOLD_EVENTS = 'setHoldEvents';
export const SET_MEDIA_LIBRARY_TYPE = 'setMediaLibraryType';
export const SET_NEW_PAGE_PATH = 'setNewPagePath';
export const SET_PAGE_DATA = 'setPageData';
export const SET_PRESET_DATA = 'setPresetData';
export const SET_PREVIEW_MODE = 'setPreviewMode';
export const SET_PROTOTYPES = 'setPrototypes';
export const SET_RENDERINGS = 'setRenderings';
export const SET_COLLECTION_DATA = 'setCollectionData';
export const SET_COPIED_MENU_DATA = 'setCopiedMenuData';
export const SET_COMPONENT_DATA = 'setComponentData';
export const CLEAR_COMPONENT_DATA = 'clearComponentData';
export const SET_COMPONENT_DATA_LIST = 'setComponentDataList';
export const SET_COMPONENT_LIST = 'setComponentList';
export const SET_COORDINATES = 'setCoordinates';
export const SET_DELETED_MENU_DATA = 'setDeletedMenuData';
export const SET_DYNAMIC_MAP_PREVIEW_MODE = 'setDynamicMapPreviewMode';
export const SET_DRAGGING_COMPONENT = 'setDraggingComponent';
export const SET_LAST_COMPONENT_ID = 'setLastComponentId';
export const SET_LAST_PAGE_ID = 'setLastPageId';
export const SET_PAGE_LOCK = 'setPageLock';
export const SET_SELECTED_COMPONENT = 'setSelectedComponent';
export const SET_SELECTED_COMPONENT_METADATA = 'setSelectedComponentMetada';
export const SET_SELECTED_CONTENT = 'setSelectedContent';
export const SET_SELECTED_ELEMENT = 'setSelectedElement';
export const SET_SELECTED_GROUP = 'setSelectedGroup';
export const SET_SELECTED_LINK = 'setSelectedLink';
export const SET_SELECTED_MEDIA = 'setSelectedMedia';
export const SET_SELECTED_MEDIA_TARGET = 'setSelectedMediaTarget';
export const SET_SELECTED_RENDERING = 'setSelectedRendering';
export const SET_TEMPLATES = 'setTemplates';
export const SET_PRESELECTED_ITEM_ID = 'setPreselectedItemId';
export const SET_WORKFLOW_STEPS = 'setWorkflowSteps';
export const SHOW_DRAWER = 'showDrawer';
export const SHOW_MODAL = 'showModal';
export const TOGGLE_ADDING_COMPONENT = 'toggleAddingComponent';
export const TOGGLE_ADDING_ORGANISMS = 'toggleAddingOrganisms';
export const TOGGLE_FAVORITE = 'toggleFavorite';
export const TOGGLE_GUIDED_SELECT = 'toggleGuidedSelect';
export const TOGGLE_PAGE_LOADING = 'togglePageLoading';
export const TOGGLE_PREVIEW = 'togglePreview';
export const TOGGLE_TOOLBAR = 'toggleToolbar';
export const TRIGGER_PAGE_CREATED = 'triggerPageCreated';
export const UNLOCK_COMPONENT = 'unlockComponent';
export const SET_VALIDATION_ERRORS = 'setValidationErrors';
export const CLEAR_VALIDATION_ERRORS = 'clearValidationErrors';

// User
export const DUMMY_USER = 'dummyUser';
export const SET_USER = 'setUser';
export const SET_USERNAME = 'setUsername';
export const SIGN_IN = 'signIn';
export const UPDATE_TOKEN = 'updateToken';
